export const countries = [
  { label: 'English', value: 'uk_UK' },
  { label: 'Francais', value: 'fr_FR' },
  { label: 'Espanol', value: 'es_ES' },
  { label: 'Italiano', value: 'it_IT' },
  { label: 'Deutsch', value: 'de_DE' },
];
export const headings = [
  {
    dosage: 'Usage and dosage',
    ingredients: 'Ingredients',
    applicationDosage: 'Application & Dosage',
    safetyWarningsTab: 'Safety & Warnings',
    safetyDataSheet: 'Safety Data Sheet',
    shopNow: 'Shop Now',
    question: 'Questions?',
    language: 'uk_UK',
    sustainability: 'BiOHY Points',
    // sustainabilityPoints: 'BiOHY Points',
    inhaltsstoffe: 'Ingredients',
    gesundheitUndSicherheit: 'Health and Safety',
    ergiebigkeit: 'Yield',
    verpackungUndVersand: 'Packaging and Shipping',
    zertifizierungen: 'Certifications',
    learnMore: 'Learn more',
    desc: 'The BiOHY points are our own rating based on five fixed criteria: ingredients, health and safety, yield, packaging and certifications. How the points are awarded is explained in our rating scale. It is not an independently verified label.',
  },
  {
    dosage: 'Application et dosage',
    ingredients: 'Ingrédients',
    applicationDosage: 'Application et dosage',
    safetyWarningsTab: 'Sécurité et avertissements',
    safetyDataSheet: 'Fiche de données de sécurité',
    shopNow: 'Acheter maintenant',
    question: 'Des questions ?',
    language: 'fr_FR',
    sustainability: 'Points BiOHY',
    // sustainabilityPoints: 'Points BiOHY',
    inhaltsstoffe: 'Ingrédients',
    gesundheitUndSicherheit: 'Santé et sécurité',
    ergiebigkeit: 'Rendement',
    verpackungUndVersand: 'Emballage et expédition',
    zertifizierungen: 'Certifications',
    learnMore: 'En savoir plus',
    desc: "Les points BiOHY sont notre propre évaluation selon cinq critères fixes : ingrédients, santé et sécurité, rendement, emballage et certifications. La manière dont les points sont attribués est expliquée dans notre barème. Il ne s'agit pas d'un label vérifié de manière indépendante.",
  },
  {
    dosage: 'Aplicación y dosificación',
    ingredients: 'Ingredientes',
    applicationDosage: 'Aplicación y dosificación',
    safetyWarningsTab: 'Seguridad y advertencias',
    safetyDataSheet: 'Ficha de datos de seguridad',
    shopNow: 'Comprar ahora',
    question: '¿Preguntas?',
    language: 'es_ES',
    sustainability: 'Puntos BiOHY',
    // sustainabilityPoints: 'Puntos BiOHY',
    inhaltsstoffe: 'Ingredientes',
    gesundheitUndSicherheit: 'Salud y seguridad',
    ergiebigkeit: 'Rendimiento',
    verpackungUndVersand: 'Embalaje y envío',
    zertifizierungen: 'Certificaciones',
    learnMore: 'Ver más',
    desc: 'Los puntos BiOHY son nuestra propia valoración según cinco criterios fijos: ingredientes, salud y seguridad, rendimiento, envase y certificaciones. Cómo se otorgan los puntos se explica en nuestra escala de valoración. No es un sello verificado de forma independiente.',
  },
  {
    dosage: 'Applicazione e dosaggio',
    ingredients: 'Ingredienti',
    applicationDosage: 'Applicazione e dosaggio',
    safetyWarningsTab: 'Sicurezza e avvertenze',
    safetyDataSheet: 'Scheda di sicurezza',
    shopNow: 'Acquista ora',
    question: 'Domande?',
    language: 'it_IT',
    sustainability: 'Punti BiOHY',
    // sustainabilityPoints: 'Punti BiOHY',
    inhaltsstoffe: 'Ingredienti',
    gesundheitUndSicherheit: 'Salute e sicurezza',
    ergiebigkeit: 'Rendimento',
    verpackungUndVersand: 'Imballaggio e spedizione',
    zertifizierungen: 'Certificazioni',
    learnMore: 'Per saperne di più',
    desc: 'I punti BiOHY sono la nostra valutazione interna basata su cinque criteri fissi: ingredienti, salute e sicurezza, resa, imballaggio e certificazioni. Il modo in cui vengono assegnati i punti è spiegato nella nostra scala di valutazione. Non è un marchio verificato in modo indipendente.',
  },
  {
    dosage: 'Anwendung und Dosierung',
    ingredients: 'Inhaltstoffe',
    applicationDosage: 'Anwendung und Dosierung',
    safetyWarningsTab: 'Sicherheit und Warnhinweise',
    safetyDataSheet: 'Sicherheitsdatenblatt',
    shopNow: 'Jetzt kaufen',
    question: 'Fragen?',
    language: 'de_DE',
    sustainability: 'BiOHY Punkte',
    // sustainabilityPoints: 'BiOHY Punkte',
    inhaltsstoffe: 'Inhaltsstoffe',
    gesundheitUndSicherheit: 'Gesundheit und Sicherheit',
    ergiebigkeit: 'Ergiebigkeit',
    verpackungUndVersand: 'Verpackung und Versand',
    zertifizierungen: 'Zertifizierungen',
    learnMore: 'Mehr erfahren',
    desc: 'Die BiOHY Punkte sind unsere eigene Bewertung nach fünf festen Kriterien: Inhaltsstoffe, Gesundheit und Sicherheit, Ergiebigkeit, Verpackung und Zertifizierungen. Wie die Punkte vergeben werden, steht in unserer Bewertungsskala. Es ist kein unabhängig geprüftes Siegel.',
  },
];
console.log('test');
